module.exports = __webpack_public_path__ + "static/media/up-arrow.bff49638.svg";